import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import authService from "./authServices";
import {toast} from "react-toastify"
const getUserfromLocalStorage = localStorage.getItem("user")
  ? JSON.parse(localStorage.getItem("user"))
  : null;
  
const initialState = {
  user: getUserfromLocalStorage,
   subscribers: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};

export const login = createAsyncThunk(
  "auth/login",
  async (userData, thunkAPI) => {
    try {
      return await authService.login(userData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
 
export const getAllSubscribers = createAsyncThunk(
  "user/getAllSubscribers",
  async (_, thunkAPI) => {
    try {
      return await authService.getSubscribers();
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        "Failed to fetch subscribers";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const sendMarketingEmail = createAsyncThunk(
  "user/sendMarketingEmail",
  async (emailData, thunkAPI) => {
    try {
      return await authService.sendMarketingEmail(emailData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || "Email sending failed");
    }
  }
);

export const deleteSubscriberById = createAsyncThunk(
  "auth/deleteSubscriber",
  async (id, thunkAPI) => {
    try {
      return await authService.deleteSubscriber(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || "Failed to delete subscriber");
    }
  }
);


export const resetState = createAction("Reset_all");


export const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {},
  extraReducers: (buildeer) => {
    buildeer
      .addCase(login.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.user = action.payload;
        state.message = "success";
      })
      .addCase(login.rejected, (state, action) => {
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
        state.isLoading = false;
      })
      .addCase(getAllSubscribers.pending, (state) => {
      state.isLoading = true;
       })

      .addCase(getAllSubscribers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.subscribers = action.payload;   // store subscribers list
      })

      .addCase(getAllSubscribers.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
        toast.error(action.payload);
      })

      .addCase(sendMarketingEmail.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(sendMarketingEmail.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        toast.success("Marketing email sent successfully!");
      })
      .addCase(sendMarketingEmail.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })
            .addCase(deleteSubscriberById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteSubscriberById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        toast.success("Subscriber deleted successfully!");
         state.subscribers = state.subscribers.filter(sub => sub._id !== action.meta.arg);
      })
      .addCase(deleteSubscriberById.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })

.addCase(resetState, () => initialState);
      
  },
});

export default authSlice.reducer;